<div class="d-flex align-items-center rounded-pill status {{ arrivalStatus }}">
  {{ tripStatus === 'Scheduled' ? 'Available' : tripStatus }}
</div>
